export default {
  category_id: null,
  description: null,
  quantity: null,
  articles: [],
  article_code: null,
  rn_no: null,
  unit: 'kg',
}
